import { cosmicSupportedCurrencies } from '@taxbit-private/cosmic-localization'
import { QUnitType } from 'dayjs'
import { z } from 'zod'

export type FetchAnchorSwapsResponse = {
  result: boolean
}

export enum AccountingStandard {
  IfrsRevaluation = 'IFRSRevaluation',
  Fasbasu = 'FASBASU',
  TaxAccounting = 'TaxAccounting',
}

export enum InventorySeparation {
  Source = 'Source',
  Universal = 'Universal',
}

export enum CostTracking {
  Fifo = 'FIFO',
  Lifo = 'LIFO',
  Hifo = 'HIFO',
  Wac = 'WeightedAverageCost',
}

export enum CostBasisCarryover {
  Sell = 'Sell',
  Transfer = 'Transfer',
}

export enum MissingCostBasis {
  Dispose = 'Dispose',
  Retroactive = 'Retroactive',
  Ignore = 'Ignore',
}

export const accountingConfigSchema = z.object({
  accounting_standard: z.nativeEnum(AccountingStandard).optional(),
  base_fiat_currency: z.enum(cosmicSupportedCurrencies).optional(),
  cost_basis_carryover: z.nativeEnum(CostBasisCarryover).optional(),
  cost_tracking: z.nativeEnum(CostTracking).optional(),
  inventory_separation: z.nativeEnum(InventorySeparation).optional(),
  missing_cost_basis: z.nativeEnum(MissingCostBasis).optional(),
  value_adjustment_frequency: z.enum(['D', 'M', 'Q', 'y']).optional(),
  use_inventory_id: z.boolean().optional(),
})

export const fetchAccountingConfigResponseSchema = z.object({
  result: accountingConfigSchema,
})

export type AccountingConfig = z.infer<typeof accountingConfigSchema>

export type FetchAccountingSettingsConfigResponse = z.infer<
  typeof fetchAccountingConfigResponseSchema
>

export type PeriodFrequency = Extract<QUnitType, 'D' | 'M' | 'Q' | 'y'>
